import { Component, OnInit } from '@angular/core';
import { Globals } from '../../_models/globals';

@Component({
  selector: 'app-delivery-challan',
  templateUrl: './delivery-challan.component.html',
  styleUrls: ['./delivery-challan.component.css']
})
export class DeliveryChallanComponent implements OnInit {

  constructor(private g: Globals) {
    this.g.page = "Delivery Challan";
  }

  ngOnInit() {
  }

}
